import { Component, inject } from '@angular/core';
import { AuthService } from "../../../services/auth.service";
import { Router } from "@angular/router";

@Component({
    selector: 'gea-shop-login-button',
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.scss'],
    standalone: false
})
export class LoginButtonComponent {

  public authService = inject(AuthService)

  constructor(
    private router: Router,
  ) {
  }

  onClick() {
    if (! this.authService.user()) {
      this.authService.showAccountModal()
    } else {
      this.router.navigate(['/customer'])
    }
  }
}
